<template>
    <div class="auth-layout">
        <router-view />
    </div>
</template>

<script>
export default {

}
</script>

<style>
@media screen and (max-width: 768px) {
    .auth-layout .box {
        box-shadow: none;
        padding: inherit;
    }
}
</style>
